<template>
  <div class="open-answer">
    <textarea 
      class="form-control mb-2" 
      v-model="userAnswer"
      rows="4"
      placeholder="Type je antwoord hier..."
      @input="updateAnswer"
    ></textarea>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

const props = defineProps({
  question: {
    type: Object,
    required: true
  },
  selectedAnswer: {
    type: [String, null],
    default: null
  }
});

const emit = defineEmits(['select-answer']);
const userAnswer = ref('');

watch(() => props.selectedAnswer, (newVal) => {
  if (newVal !== null && typeof newVal === 'string') {
    userAnswer.value = newVal;
  }
}, { immediate: true });

function updateAnswer() {
  emit('select-answer', userAnswer.value);
}
</script>
